<template>
  <common-page-edit
    :title="title"
    :nameRoleEntity="nameRoleEntity"
    :apiNameGet="apiNameGet"
    :apiNameCreate="apiNameCreate"
    :apiNameUpdate="apiNameUpdate"
    :routeNameShow="routeNameShow"
    :routeNameCreate="routeNameCreate"
    :keyRoute="'ContactId'"
    :backUrl="pathBack"
    @set-loadData="setLoadData"
    :convertLoadData="convertLoadData"
    :paramsSave="paramsSave"
    :isDefaultConverter="false"
    :paramsSend="paramsSend"
  >
  </common-page-edit>
</template>
<script>
import { API_METHODS } from "../../../../constant";
import { NAME_OBJECT } from "../../../../RoleConstanans";
import CommonPageEdit from "../../commonElement/CommonPageEdit.vue";
import CompanyData from "../company/CompanyData.vue";

import convertFieldInfoListToScheme from "../../../../helpers/converters/convetFieldInfoListToScheme";

export default {
  name: "EditPageAddresMain",
  components: {
    CommonPageEdit,
    CompanyData
  },
  data() {
    return {
      wait: false,
      scheme: {},
      loadData: null,
      fieldInfoList: null,
      preResult: null,
      load: true,

      routeNameShow: null,
      routeNameCreate: null,

      apiNameGet: API_METHODS.GET_ADDRES,
      apiNameCreate: API_METHODS.CREATE_ADDRES,
      apiNameUpdate: API_METHODS.UPDATE_ADDRES,
      loadData: null
    };
  },
  computed: {
    title() {
      let text1 = this.$t("Просмотр адреса");
      let text2 = this.$t("Создание адреса");
      let text3 = this.$t("Редактирование адреса");

      let findShow = this.$route.path.indexOf("show");
      if (findShow != -1) {
        return text1;
      }
      let findCreate = this.$route.path.indexOf("create");
      if (findCreate != -1) {
        return text2;
      }
      let findEdit = this.$route.path.indexOf("edit");
      if (findEdit != -1) {
        return text3;
      }
      return text1;
    },
    meta() {
      return this.$route.meta;
    },
    nameRoleEntity() {
      const nameRoute = this.$route.name;
      let role = "CompanyAddress";

      switch (nameRoute) {
        case "AgentCreatePageAddress":
        case "AgentShowPageAddress":
        case "AgentEditPageAddress": {
          role = NAME_OBJECT.AddressAgency;
          break;
        }
        case "ClientEditPageAddress":
        case "ClientShowPageAddress":
        case "ClientCreatePageAddress": {
          role = NAME_OBJECT.AddressClient;
          break;
        }
      }

      return role;
    },
    pathBack() {
      return `/company/${this.meta.typeCompany}/${this.$route.params.CompanyId}/edit`;
    },
    paramsSend() {
      return {
        id: this.$route.params.ContactId || "0",
        SubjectId: this.$route.params[this.meta.fieldRoute]
      };
    }
  },
  created() {
    this.routeNameShow = this.meta.routeNameShow;
    this.routeNameCreate = this.meta.routeNameCreate;
  },
  methods: {
    convertLoadData(res) {
      let loadData = res.object;
      let fieldInfoList = res.fieldInfoList;
      let scheme = { configForm: [] };

      scheme.configForm = convertFieldInfoListToScheme({
        fieldInfoList,
        hasLang: false
      });

      return {
        loadData,
        fieldInfoList,
        scheme
      };
    },
    setLoadData(loadData) {
      this.loadData = loadData;
    },
    paramsSave() {
      return {
        id: this.$route.params.ContactId,
        SubjectId: this.$route.params[this.meta.fieldRoute]
      };
    }
  }
};
</script>
